import React from 'react';
import './TextButton.scss';
export const TextButton = ({ disabled, onClick, children }) => {
    return (React.createElement("button", { className: "CSVImporter_TextButton", type: "button" // avoid triggering form submit
        , disabled: disabled, onClick: onClick }, children));
};
